(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CustomerGroupV2Controller', CustomerGroupV2Controller);

    CustomerGroupV2Controller.$inject = ['$rootScope', '$scope', '$state', 'CustomerGroup', 'PersonInfo', 'ParseLinks', 'AlertService', 'entity', 'CustomerGroupCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', '$translate'];

    function CustomerGroupV2Controller($rootScope, $scope, $state, CustomerGroup, PersonInfo, ParseLinks, AlertService, entity, CustomerGroupCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, translate) {

        var vm = this;
        vm.customerGroup = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allServiceItems = [];
        vm.switch_changed = switch_changed;


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;


        initDefault();
        loadAll();

        function initDefault() {
            $rootScope.$broadcast('hideNavBar');
        }

        function loadAll() {
            if (vm.customerGroup.accessToAllServices == undefined)
                vm.customerGroup.accessToAllServices = true;

            if (vm.customerGroup.groupName == 'DEFAULT_GROUP') {
                vm.defaultGroupTranslate = translate.instant('tikonApp.customerGroup.DEFAULT_GROUP');
            }

            $translatePartialLoader.addPart('companyCustomer');
            getAllServices();

        }

        function save() {
            vm.isSaving = true;
            addServiceItems();

            if (vm.customerGroup.id !== null) {
                CustomerGroup.update(vm.customerGroup, onSaveSuccess, onSaveError);
            } else {

                CustomerGroup.save(vm.customerGroup, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:customerGroupUpdate', result);
                vm.isSaving = false;
                $state.go('supplierPanel-v2.editCustomerGroup', {id: result.id});
                loadAll();

            }

        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.customerGroupList');

        }

        function getModalTitle() {
            if (vm.customerGroup.id)
                return 'tikonApp.customerGroup.home.edit';
            else
                return 'tikonApp.customerGroup.home.new';
        }

        function getAllServices() {

            ServiceItemCustom.getServiceItemsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allServiceItems = result;
                    makeServicesSelectedOnLoad();
                }
            );
        }

        function switch_changed() {

            angular.forEach(vm.allServiceItems, function (item) {
                if (vm.customerGroup.accessToAllServices)
                    item.selected = true;
                else
                    item.selected = false;
            })


        }

        function addServiceItems() {

            vm.customerGroup.serviceItems = [];
            angular.forEach(vm.allServiceItems, function (item) {

                if (item.selected) {
                    vm.customerGroup.serviceItems.push(item);
                }

            })
        }

        function makeServicesSelectedOnLoad() {


            if (vm.customerGroup.serviceItems && vm.customerGroup.serviceItems.length > 0) {


                angular.forEach(vm.customerGroup.serviceItems, function (item) {
                    angular.forEach(vm.allServiceItems, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;

                    })

                })

            }
        }


    }
})();
